import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  allActiveMusicArray,
  getAllProducts,
  getAllVedios,
  sendbookmark,
} from ".";
import { isAuthenticated } from "../../Auth/helper";
import { API, DOMAINNAME } from "../../backend";
import LoggedInNavbar from "./loggedInNavbar";
import ReactPlayer from "react-player/lazy";
import { useTheme } from "@mui/material/styles";
import { Link, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";

const MediaPlay = () => {
  const { userId, musicId } = useParams();
  console.log(userId);
  let mediatype = 1;
  const navigate = useNavigate();
  let [products, setAllProducts] = useState([]);
  let [playval, setplayval] = useState({
    isplay: false,
    itemid: "",
  });
  let [isReady, setReady] = useState(false);
  let [playmedia, setmedia] = useState(false);
  let [recentlyplayed, setplayed] = useState([]);
  let [linkPlay, setLinkPlay] = useState(0);
  let [bookmarkarray, setbookmark] = useState([]);
  let [recommended, setRecommended] = useState([]);
  let [showbmcolor, getbmcolor] = useState([]);
  let [share, setshare] = useState([]);
  let [mainCat, setMainCat] = useState([]);
  let [catThumbNail, setCatThumbNail] = useState([]);
  const theme = useTheme();
  const { isplay, itemid } = playval;

  const playerref = React.useRef();

  const showmyFav = () => {
    console.log(bookmarkarray);
    return (
      <>
        {bookmarkarray.map((item, key) => {
          console.log("This is undermap", bookmarkarray);
          return (
            <>
              <span
                style={{ cursor: "pointer", fontSize: "20px", height: "50px" }}
              >
                <div
                  className=" card w-75"
                  style={{
                    backgroundColor: "#05445E",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    console.log(item._id);
                    setplayval({
                      isplay: true,
                      itemid: item.prouctId,
                      user: isAuthenticated().user._id,
                    });
                    setReady(false);

                    getActiveMusicArray();
                  }}
                >
                  <div className="card-body">
                    <h6 className="card-title">
                      {" "}
                      <i className="fa fa-play-circle"></i>
                      {item.productName}
                    </h6>
                    <p className="card-text"> </p>
                  </div>
                </div>
              </span>
              <br />
            </>
          );
        })}
      </>
    );
  };

  const getActiveMusicArray = async () => {
    let c = isAuthenticated();
    await allActiveMusicArray(c.user._id, c.token)
      .then((as) => {
        setplayed(as?.ActiveMusic || []);
      })
      .catch((e) => {
        alert("Failed to load resource");
        return false;
      });
  };

  const checkSignedIn = (id) => {
    const isSignedin =
      isAuthenticated() &&
      isAuthenticated().token &&
      isAuthenticated().user._id;
    if (isSignedin) {
      navigate(`/player?id=${id}`);
    } else {
      navigate("/signin");
    }
  };

  useEffect(() => {
    console.log("This is myfav nav");
    showmyFav();
  }, [bookmarkarray]);

  const bookmark = async (uuid) => {
    console.log("Gello Man");
    console.log(bookmarkarray);
    let cc = isAuthenticated();
    getbmcolor([...showbmcolor, uuid]);
    if (bookmarkarray.find((x) => x.prouctId == uuid)) {
      return false;
    }

    await sendbookmark(cc.user._id, cc.token, { productId: uuid })
      .then((rep) => {
        console.log(rep);

        setbookmark([...bookmarkarray, rep]);
      })
      .catch((e) => {
        console.log("error");
      });
  };

  const showMedia = () => {
    //  console.log( isAuthenticated().user.ActiveMusic)
    // console.log("thi is  showmedia rnder")

    return (
      <div>
        <ReactPlayer
          style={{
            padding: "15px",
            width: "100%",
            height: "auto",
            margin: "0 auto",
          }}
          height="auto"
          width="90%"
          ref={playerref}
          url={playmedia}
          playing={true}
          controls={true}
          config={{
            file: {
              attributes: {
                controlsList: "nodownload", //<- this is the important bit
              },
            },
          }}
          onReady={readyState}
          progressInterval={1000}
          onProgress={(r) => {
            watchedvedio(linkPlay, r.playedSeconds);
          }}
          onEnded={() => {
            watchedvedio(linkPlay, 0);
          }}
        />
      </div>
    );
  };

  const readyState = async () => {
    console.log("rerendering");

    let sec = 0;

    //  console.log(itemid)

    let cur = isAuthenticated();

    await allActiveMusicArray(cur.user._id, cur.token).then((repo) => {
      console.log(itemid);

      (repo?.ActiveMusic || []).map((q) => {
        if (q.itemid == itemid) {
          sec = parseInt(q.seconds);
          console.log("Seconds are", sec);
        }
      });
    });

    //    await isAuthenticated().user.ActiveMusic.map((e)=>{

    //             if(e.itemid===itemid)
    //               {
    //               console.log(e.seconds)
    //               sec=parseInt(e.seconds)
    //               }
    //           })

    console.log(sec);

    if (!isReady) {
      console.log(sec);

      await playerref.current?.seekTo(parseInt(sec));
      setReady(!isReady);
    }
  };

  const watchedvedio = async (item_id, playedSeconds) => {
    let getvalues = await isAuthenticated();

    let newvl = { itemid: item_id, seconds: Math.floor(playedSeconds) };

    return await fetch(`${API}user/savedata/${getvalues.user._id}/${item_id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getvalues.token}`,
      },

      body: JSON.stringify({ ActiveMusic: newvl }),
    });
  };

  useEffect(() => {
    console.log("This is useeffect");
    const fetchdata = async () => {
      try {
        let c = await isAuthenticated();
        const { token, user } = c;

        let search = window.location.search;
        let params = new URLSearchParams(search);
        let foo = params.get("way");
        setmedia(foo);
        setplayval({ isplay: true, itemid: userId });
        setLinkPlay(userId);
        await getAllVedios(user._id, token)
          .then((x) => {
            console.log(x);
            setAllProducts(x);
          })
          .catch();

        await allActiveMusicArray(c.user._id, c.token)
          .then((as) => {
            console.log(as.Bookmark);
            let newBookmark = new Array();
            as.Bookmark.map((r, n) => {
              console.log(r);
              if (r.CategoryName == mediatype) {
                console.log("helo");
                newBookmark.push(r);
              }
            });
            console.log(newBookmark);

            setplayed(as?.ActiveMusic || []);
            setbookmark(newBookmark.reverse());
          })
          .catch((e) => {
            alert("Failed to load resource");
            return false;
          });
      } catch {}
    };

    fetchdata();
    //getActiveMusicArray()
  }, []);

  return (
    <div>
      <LoggedInNavbar />
      <br />
      <div className="container-fluid">
        <div style={{ marginBottom: "20px" }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              background: "#E34607",
              color: "white",
              border: "none",
              borderRadius: "8px",
              padding: "10px 15px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            <i className="fas fa-arrow-left"></i>
            Back
          </button>
        </div>
        <center>
          {showMedia()}

          <h4 style={{ color: "#E34607", lineHeight: "34px", padding: "20px" }}>
            {products !== undefined
              ? products.filter((item) => item._id === linkPlay)[0]?.productName
              : "Videotitle"}
          </h4>
          <p>
            {products !== undefined
              ? products.filter((item) => item._id === linkPlay)[0]?.Description
              : ""}
          </p>

          <i
            className="fa fa-thumbs-up"
            onClick={() => bookmark(linkPlay)}
            style={{
              color: "grey",
              margin: "15px",
              padding: "15px",
              fontSize: "25px",
              fontSize: "25px",
              cursor: "pointer",
              color:
                showbmcolor.find((x) => {
                  return x == linkPlay;
                }) ||
                bookmarkarray.find((c) => {
                  return c.prouctId == linkPlay;
                })
                  ? "#E34607"
                  : "grey",
            }}
          ></i>

          <a
            href={playmedia}
            style={{
              color: "grey",
              margin: "15px",
              padding: "15px",
              fontSize: "25px",
              cursor: "pointer",
              textDecoration: "none !important",
            }}
          >
            {" "}
            <i className="fa fa-download" target="_blank"></i>{" "}
          </a>

          <i
            className="fa fa-share"
            style={{
              color: "grey",
              margin: "15px",
              padding: "15px",
              fontSize: "25px",
              cursor: "pointer",
              textDecoration: "none !important",
            }}
            onClick={() => {
              let incomming =
                products !== undefined &&
                products.filter((item) => item._id === linkPlay)[0];
              navigator.clipboard.writeText(
                `https://harikrishnamandir.org/player/${incomming?._id}/${incomming?.productCategory?._id}?way=${playmedia}`
              );
              alert("Link copied to clipboard");
            }}
          ></i>
        </center>

        <br />

        <div className="row">
          {products.map((item, key) => {
            return (
              <div className="col-sm-4" style={{ padding: "13px" }}>
                <center>
                  <div
                    className="card"
                    style={{
                      flexDirection: "row",
                      cursor: "pointer",
                      backgroundColor:
                        (isAuthenticated().user?.ActiveMusic || []).some((q) => {
                          if (q.itemid === item._id) {
                            return true;
                          }
                        }) ||
                        (recentlyplayed || []).some((w) => {
                          if (w.itemid == item._id) {
                            return true;
                          }
                        })
                          ? "#EAEAEA"
                          : "#F5F5F5",
                      color: "black",
                      height: "100px",
                    }}
                    onClick={() => {
                      setLinkPlay(item._id);
                      setmedia(item.productPathCDN);
                      setplayval({
                        isplay: true,
                        itemid: item._id,
                        user: isAuthenticated().user._id,
                      });
                      setReady(false);
                      getActiveMusicArray();
                    }}
                  >
                    <LazyLoadImage
                      style={{ width: "30%" }}
                      src={item.thumbNailPathCDN}
                      alt="gvg"
                      loading="lazy"
                    />
                    <div className="card-body">
                      <h6 className="card-title">{item.productName}</h6>
                    </div>
                  </div>
                </center>
              </div>
            );
          })}
        </div>

        <h2 style={{ color: "#E34607", lineHeight: "34px", padding: "20px" }}>
          Recently viewed
        </h2>

        <div className="row">
          {products
            .filter((item) => {
              return (recentlyplayed || []).some((i) => {
                return i.itemid === item._id;
              });
            })
            .map((item) => {
              return (
                <div className="col-sm-4" style={{ padding: "13px" }}>
                  <center>
                    <div
                      className="card"
                      style={{
                        flexDirection: "row",
                        cursor: "pointer",
                        backgroundColor:
                          (isAuthenticated().user?.ActiveMusic || []).some((q) => {
                            if (q.itemid === item._id) {
                              return true;
                            }
                          }) ||
                          (recentlyplayed || []).some((w) => {
                            if (w.itemid == item._id) {
                              return true;
                            }
                          })
                            ? "#EAEAEA"
                            : "#F5F5F5",
                        color: "black",
                        height: "100px",
                      }}
                      onClick={() => {
                        setLinkPlay(item._id);
                        setmedia(item.productPathCDN);
                        setplayval({
                          isplay: true,
                          itemid: item._id,
                          user: isAuthenticated().user._id,
                        });
                        setReady(false);
                        setshare(item);
                        getActiveMusicArray();
                      }}
                    >
                      <LazyLoadImage
                        style={{ width: "30%" }}
                        src={item.thumbNailPathCDN}
                        alt="gvg"
                        loading="lazy"
                      />
                      <div className="card-body">
                        <h6 className="card-title">{item.productName}</h6>
                      </div>
                    </div>
                  </center>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default React.memo(MediaPlay);
